<div class="text-center">
    <video style="width: 100%;" controls controlsList="nodownload" autoplay>
        <source [src]="serverAddress + 'video/stream/' + idVideo" type="video/mp4">
        Your browser does not support the video tag.
    </video>
</div>
